export default "__VITE_ASSET__JA7XcFm0__"